import { Card, CardBody, Loader, Table } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { streamsWithOffsetRequiredAtom } from '../../atoms/offsetRequired';
import CardHeader from '../../components/CardHeader';
import { CellHeadings } from '../../components/CellHeadings/CellHeadings';
import OffsetRequiredTableRows from '../../components/OffsetRequiredTableRows';
import VideoFilters from '../../components/VideoFilters';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import { useVideoDataForAlignmentCheck } from '../../hooks/loadVideosRequiringAlignmentCheck';
import convertKeys from '../../utils/convertKeys';
import { filterVideos } from '../../utils/videoEvents';
import getOffsetRequiredHeadingCells from '../offsetRequired.helper';

export function OffsetRequired() {
  const intl = useIntl();
  const [competitions, setCompetitions] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [matchId, setMatchId] = useState('');
  const [streamsWithOffsetRequired, setStreamsWithOffsetRequired] = useAtom(
    streamsWithOffsetRequiredAtom,
  );
  const { get, errorMessage, isFetching } = useApi();

  useVideoDataForAlignmentCheck(
    streamsWithOffsetRequired?.map((stream) => ({
      ...stream.videoReference,
      ...stream.videoInfo,
    })),
  );

  const filteredOffsetRequiredEvents = useMemo(
    () =>
      filterVideos(
        streamsWithOffsetRequired,
        competitions,
        seasons,
        undefined,
        undefined,
        matchId,
      ),
    [streamsWithOffsetRequired, competitions, seasons, matchId],
  );

  useEffect(() => {
    const fetchStreams = async () => {
      const response = await get(
        `${API_ENDPOINTS.videoService}/streams/requiring-offset`,
      );

      setStreamsWithOffsetRequired(
        convertKeys(response?.data?.streams_requiring_offset),
      );
    };

    fetchStreams();
  }, []);

  if (isFetching) {
    return <Loader />;
  }

  if (errorMessage) {
    return (
      <div>
        {intl.formatMessage({
          defaultMessage: 'Error getting streams requiring offset',
          id: 'c633b',
        })}
        : {errorMessage}
      </div>
    );
  }

  if (streamsWithOffsetRequired && streamsWithOffsetRequired.length < 1) {
    return (
      <div>
        {intl.formatMessage({
          defaultMessage: 'No streams require offsets',
          id: '4378b',
        })}
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <FormattedMessage defaultMessage="Alignment Queue" id="76410" />
      </CardHeader>
      <VideoFilters
        competitions={competitions}
        seasons={seasons}
        matchId={matchId}
        setCompetitions={setCompetitions}
        setSeasons={setSeasons}
        setMatchId={setMatchId}
        videos={streamsWithOffsetRequired}
      />
      <CardBody>
        <Table>
          <CellHeadings cells={getOffsetRequiredHeadingCells(intl)} />
          <Table.Body>
            <OffsetRequiredTableRows streams={filteredOffsetRequiredEvents} />
          </Table.Body>
        </Table>
      </CardBody>
    </Card>
  );
}

export default { OffsetRequired };
